import { requestStateData } from './requestStateData'
import { useStateData } from './useStateData'
import { SignupState } from '../types'

export const fetchBanner = () =>
  requestStateData(
    'banner',
    ({
      signupSession: { instantInkService },
      localization,
      partialSubscription
    }: SignupState) =>
      instantInkService.fetchBanner(
        partialSubscription?.data?.id,
        localization?.language,
        localization?.country
      )
  )

export const useBanner = () =>
  useStateData(
    'banner',
    fetchBanner,
    ({ partialSubscription }) => partialSubscription?.data?.id !== undefined
  )
